import { cx } from '@linaria/core';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { USER_AREA_BASE_PATH } from '@pm2/api';
import { useTrackingManager } from '@provider/tracking';
import { Link } from '@ui/kit';
import { HeartIcon } from '@ui/kit/icons';
import { CSSRefTransition, SizeTransition } from '@utils/react';
import { Routes } from '../../../const.routes.js';
import { getFavouritesQuery } from '../api/get-favourites.query.js';
import { FavouriteCard } from '../molecule.favourite-card/_favourite-card.js';
import { getInternalKeyForFavouriteDescriptor } from '../util.get-internal-key.js';
import { heading } from './_portal-page.style.js';
import { wrapper, header, headingHeart, link, content, pageFadeDurationMs, message, list, listItem, cardExitDurationMs, empty } from './molecule.favourites-section.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FavouritesSection() {
  const tracker = useTrackingManager();
  const favourites = useQuery(getFavouritesQuery.useQueryConfig());
  const sortedFavourites = useMemo(() => favourites.data?.sort((a, b) => (b.createdAt?.getTime() ?? 0) - (a.createdAt?.getTime() ?? 0)), [favourites.data]);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsxs("div", {
      className: header,
      children: [/*#__PURE__*/jsxs("h2", {
        className: heading,
        children: ["Dine favoritter", !sortedFavourites?.length && /*#__PURE__*/jsx("span", {
          className: headingHeart,
          role: "presentation",
          children: /*#__PURE__*/jsx(HeartIcon, {})
        })]
      }), !!sortedFavourites?.length && /*#__PURE__*/jsx(Link, {
        className: link,
        theme: "secondary",
        href: `${USER_AREA_BASE_PATH}/${Routes.FAVOURTIES}`,
        onClick: () => {
          tracker.trackEvent("userarea.navigation.toFavouritesPage", {
            method: "frontpage-link"
          });
        },
        children: "Se alle"
      })]
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: favourites.isPending ? /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: pageFadeDurationMs,
        classNames: content,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: cx(content, message),
          children: "Indl\xE6ser..."
        })
      }) : /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: pageFadeDurationMs,
        classNames: content,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: content,
          children: sortedFavourites?.length ? /*#__PURE__*/jsx("ul", {
            className: list,
            children: /*#__PURE__*/jsx(TransitionGroup, {
              component: null,
              children: sortedFavourites.slice(0, 4).map(it => /*#__PURE__*/jsx(SizeTransition, {
                axis: "horisontal",
                timeout: cardExitDurationMs,
                classNames: listItem,
                children: ref => /*#__PURE__*/jsx("li", {
                  ref: ref,
                  className: listItem,
                  children: /*#__PURE__*/jsx("div", {
                    children: /*#__PURE__*/jsx(FavouriteCard, {
                      context: "frontpage",
                      descriptor: it
                    })
                  })
                })
              }, getInternalKeyForFavouriteDescriptor(it)))
            })
          }) : /*#__PURE__*/jsx("div", {
            className: empty,
            children: "Mark\xE9r dine favoritter, s\xE5 har du dem lige ved h\xE5nden ..."
          })
        })
      })
    })]
  });
}

export { FavouritesSection };
//# sourceMappingURL=molecule.favourites-section.js.map
